/**
 * Custom element that checks if a product fits the user's selected machine
 * @extends HTMLElement
 */
class MachineFit extends HTMLElement {
  /**
   * Initialize the element and check machine compatibility
   */
  connectedCallback() {
    // Get DOM elements
    const elements = {
      fitsYourMachine: this.querySelector('[data-fits-your-machine]'),
      doesNotFitYourMachine: this.querySelector('[data-does-not-fit-your-machine]'),
      noMachineSelected: this.querySelector('[data-no-machine-selected]'),
      loadingOverlay: this.querySelector('[data-loading-overlay]'),
      scriptTag: this.querySelector('[data-models]'),
    };

    // Store elements as class properties
    Object.assign(this, elements);

    const controller = window.getMachineController?.();
    if (!controller) return;

    const evaluate = (machineData) => this.checkMachineCompatibility(machineData);

    evaluate(controller.getCurrentState());
    this.unsubscribe = subscribe('machine:change', evaluate);
  }

  disconnectedCallback() {
    if (this.unsubscribe) this.unsubscribe();
  }

  /**
   * Check if the product is compatible with the selected machine
   * @param {object} machineData - Current machine data from MachineController
   */
  // eslint-disable-next-line complexity
  checkMachineCompatibility(machineData) {
    const hasSelection = !!machineData?.model;

    if (!hasSelection) {
      this.noMachineSelected?.classList.remove('hidden');
      this.loadingOverlay?.classList.add('hidden');
      //this.updateFitStatus(false);
      return;
    }

    this.noMachineSelected?.classList.add('hidden');

    try {
      const { models } = JSON.parse(this.scriptTag?.textContent || '{}');
      const modelTitle = (machineData.model || '').toUpperCase();
      const isMatch = models?.some((model) => model.title === modelTitle);

      this.updateFitStatus(isMatch);
    } catch (error) {
      console.error('Error checking machine compatibility:', error);
    }
  }

  /**
   * Update the UI to show if the product fits the machine
   * @param {boolean} isMatch - Whether the product fits the machine
   */
  updateFitStatus(isMatch) {
    this.loadingOverlay?.classList.add('hidden');

    const elements = {
      fits: this.fitsYourMachine,
      doesNotFit: this.doesNotFitYourMachine,
    };

    // Update visibility based on match status
    Object.entries(elements).forEach(([key, element]) => {
      element?.classList.toggle('hidden', key === 'fits' ? !isMatch : isMatch);
    });
  }
}

customElements.define('machine-fit', MachineFit);
